import type { PlatformTypes } from '@/types/gql.generated';

// Deliberately a leaf module: the destination entries import it at init, so
// it must not import the registry (whose init runs the entries) — the
// registry-reading resolvers live in registry.ts instead.

/**
 * The `useIsAvailable` value for destinations with no gating — a real hook so
 * every module declares availability the same way, letting the registry tests
 * pin exactly which modules are flag-gated.
 */
export const useAlwaysAvailable = (): boolean => true;

/**
 * Which flag-gated destinations are currently on. Platforms absent from the
 * record count as available — so list resolution takes the full
 * useDestinationAvailability record (an absent gate would activate that
 * module's stand-in), while degradeUnavailablePlatform callers pass a scoped
 * subset covering just the degrades they own.
 */
export type DestinationAvailability = Partial<Record<PlatformTypes, boolean>>;
